import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Import pages/components for routing
import Home from './components/Home';
import About from './components/About';
import Courses from './components/Courses';
import Freelance from './components/Freelance';
import Contact from './components/Contact';
import SupportSection from './components/SupportSection';
import CourseEnroll from './components/ui/CourseEnroll';


function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/CourseEnroll" element={<CourseEnroll />} />

        <Route path="/courses" element={<Courses />} />
        <Route path="/freelance" element={<Freelance />} />
        <Route path="/contact" element={<Contact />} />
       
      </Routes>
<SupportSection/>
      <Footer />
    </Router>
  );
}

export default App;
